import { Controller } from "@hotwired/stimulus"
import { stimulus } from "~/init"

class MileageInputController extends Controller {
  connect () {
    this.element.setAttribute("type", "text")
    this.element.setAttribute("inputmode", "numeric")
    this.element.setAttribute("autocomplete", "off")

    if (this.element.value) {
      this.element.value = this.#format(this.element.value)
    }

    this._onFormdata = this.#cleanFormdata.bind(this)
    this.element.form?.addEventListener("formdata", this._onFormdata)
  }

  disconnect () {
    this.element.form?.removeEventListener("formdata", this._onFormdata)
  }

  input () {
    const raw = this.element.value.replace(/\D/g, "")
    const selStart = this.element.selectionStart
    const digitsBeforeCursor = this.element.value.slice(0, selStart).replace(/\D/g, "").length

    this.element.value = this.#format(raw)

    let count = 0
    let newPos = 0
    for (let i = 0; i < this.element.value.length; i++) {
      if (/\d/.test(this.element.value[i])) count++
      if (count === digitsBeforeCursor) { newPos = i + 1; break }
    }
    this.element.setSelectionRange(newPos, newPos)
  }

  get rawValue () {
    return this.element.value.replace(/\D/g, "")
  }

  #format (value) {
    const num = String(value).replace(/\D/g, "")
    if (!num) return ""
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  }

  #cleanFormdata (event) {
    const name = this.element.name
    if (!name) return
    event.formData.set(name, this.rawValue)
  }
}

stimulus.register("mileage-input", MileageInputController)
